export {
  X_PROFILE_URL,
  YOUTUBE_CHANNEL_VIDEOS_URL,
  YOUTUBE_TUTORIAL_EMBED_URL,
  YOUTUBE_TUTORIAL_PAGE_PLAY_EMBED_URL,
  YOUTUBE_TUTORIAL_PLAY_EMBED_URL,
  YOUTUBE_TUTORIAL_THUMBNAIL_SIZES,
  YOUTUBE_TUTORIAL_THUMBNAIL_SRCSET,
  YOUTUBE_TUTORIAL_THUMBNAIL_URL,
  YOUTUBE_TUTORIAL_URL,
  YOUTUBE_TUTORIAL_VIDEO_ID,
} from '../../lib/tutorialLinks';

export const SEARCH_LEARN_MORE_SLUG = 'dev-offer-search-001-a-xa5z-learn-more-001';
export const SEARCH_LEARN_MORE_PATH = `/landing/${SEARCH_LEARN_MORE_SLUG}`;

export const PERFMAX_LEARN_MORE_SLUG = 'dev-offer-000001-a-x9k2m-learn-more-001';
export const PERFMAX_LEARN_MORE_PATH = `/landing/${PERFMAX_LEARN_MORE_SLUG}`;

export const VIDEO_AD_A_SLUG = 'dev-offer-2026-avce';
export const VIDEO_AD_A_PATH = `/landing/${VIDEO_AD_A_SLUG}`;
export const VIDEO_AD_A_LEARN_MORE_SLUG = `${VIDEO_AD_A_SLUG}-learn-more-001`;
export const VIDEO_AD_A_LEARN_MORE_PATH = `/landing/${VIDEO_AD_A_LEARN_MORE_SLUG}`;

export const DIRECT_DOWNLOAD_SLUG = 'download-001-a-xcbz';
export const DIRECT_DOWNLOAD_PATH = `/${DIRECT_DOWNLOAD_SLUG}`;
export const DIRECT_DOWNLOAD_LEARN_MORE_SLUG = `${DIRECT_DOWNLOAD_SLUG}-learn-more-001`;
export const DIRECT_DOWNLOAD_LEARN_MORE_PATH = `/${DIRECT_DOWNLOAD_LEARN_MORE_SLUG}`;
export const DIRECT_DOWNLOAD_B_SLUG = 'download-001-b-k9v4r';
export const DIRECT_DOWNLOAD_B_PATH = `/${DIRECT_DOWNLOAD_B_SLUG}`;
export const DIRECT_DOWNLOAD_B_LEARN_MORE_SLUG = `${DIRECT_DOWNLOAD_B_SLUG}-learn-more-001`;
export const DIRECT_DOWNLOAD_B_LEARN_MORE_PATH = `/${DIRECT_DOWNLOAD_B_LEARN_MORE_SLUG}`;

export const YOUTUBE_PROMO_A_SLUG = 'youtube-promo-code-001-a-2026-xybc';
export const YOUTUBE_PROMO_A_PATH = `/${YOUTUBE_PROMO_A_SLUG}`;
export const YOUTUBE_PROMO_A_LEARN_MORE_SLUG = `${YOUTUBE_PROMO_A_SLUG}-learn-more-001`;
export const YOUTUBE_PROMO_A_LEARN_MORE_PATH = `/${YOUTUBE_PROMO_A_LEARN_MORE_SLUG}`;
export const YOUTUBE_PROMO_B_SLUG = 'youtube-promo-code-001-b-2026-xyjq';
export const YOUTUBE_PROMO_B_PATH = `/${YOUTUBE_PROMO_B_SLUG}`;
export const YOUTUBE_PROMO_B_LEARN_MORE_SLUG = `${YOUTUBE_PROMO_B_SLUG}-learn-more-001`;
export const YOUTUBE_PROMO_B_LEARN_MORE_PATH = `/${YOUTUBE_PROMO_B_LEARN_MORE_SLUG}`;
export const YOUTUBE_PROMO_ALLOCATOR_SLUG = 'youtube-promo-code-001-2026-xyb1';
export const YOUTUBE_PROMO_ALLOCATOR_PATH = `/${YOUTUBE_PROMO_ALLOCATOR_SLUG}`;

export const YOUTUBE_SIMPLE_SLUG = 'youtube';
export const YOUTUBE_SIMPLE_PATH = `/${YOUTUBE_SIMPLE_SLUG}`;
export const YOUTUBE_SIMPLE_LEARN_MORE_SLUG = `${YOUTUBE_SIMPLE_SLUG}-learn-more-001`;
export const YOUTUBE_SIMPLE_LEARN_MORE_PATH = `/${YOUTUBE_SIMPLE_LEARN_MORE_SLUG}`;

export const YOUTUBE_CLI_SLUG = 'youtube-cli';
export const YOUTUBE_CLI_PATH = `/${YOUTUBE_CLI_SLUG}`;
export const YOUTUBE_CLI_LEARN_MORE_SLUG = `${YOUTUBE_CLI_SLUG}-learn-more-001`;
export const YOUTUBE_CLI_LEARN_MORE_PATH = `/${YOUTUBE_CLI_LEARN_MORE_SLUG}`;

export const X_PROMO_A_SLUG = 'x-promo-code-001-a-2026-q8vn';
export const X_PROMO_A_PATH = `/${X_PROMO_A_SLUG}`;
export const X_PROMO_A_LEARN_MORE_SLUG = `${X_PROMO_A_SLUG}-learn-more-001`;
export const X_PROMO_A_LEARN_MORE_PATH = `/${X_PROMO_A_LEARN_MORE_SLUG}`;
export const X_PROMO_B_SLUG = 'x-promo-code-001-b-2026-m4pz';
export const X_PROMO_B_PATH = `/${X_PROMO_B_SLUG}`;
export const X_PROMO_B_LEARN_MORE_SLUG = `${X_PROMO_B_SLUG}-learn-more-001`;
export const X_PROMO_B_LEARN_MORE_PATH = `/${X_PROMO_B_LEARN_MORE_SLUG}`;
export const X_PROMO_ALLOCATOR_SLUG = 'x-promo-code-001-2026-q8x1';
export const X_PROMO_ALLOCATOR_PATH = `/${X_PROMO_ALLOCATOR_SLUG}`;

export const X_PROMO_2026_A_SLUG = 'x-promo-code-2026-xybz-a';
export const X_PROMO_2026_A_PATH = `/${X_PROMO_2026_A_SLUG}`;
export const X_PROMO_2026_A_LEARN_MORE_SLUG = `${X_PROMO_2026_A_SLUG}-learn-more-001`;
export const X_PROMO_2026_A_LEARN_MORE_PATH = `/${X_PROMO_2026_A_LEARN_MORE_SLUG}`;
export const X_PROMO_2026_B_SLUG = 'x-promo-code-2026-xzkj-b';
export const X_PROMO_2026_B_PATH = `/${X_PROMO_2026_B_SLUG}`;
export const X_PROMO_2026_B_LEARN_MORE_SLUG = `${X_PROMO_2026_B_SLUG}-learn-more-001`;
export const X_PROMO_2026_B_LEARN_MORE_PATH = `/${X_PROMO_2026_B_LEARN_MORE_SLUG}`;
export const X_PROMO_2026_ALLOCATOR_SLUG = 'x-promo-code-2026-xybz';
export const X_PROMO_2026_ALLOCATOR_PATH = `/${X_PROMO_2026_ALLOCATOR_SLUG}`;
export const DEVELOPERS_CLI_2026_AXYZ23_SLUG = 'developers-cli-2026-axyz23';
export const DEVELOPERS_CLI_2026_AXYZ23_PATH = `/${DEVELOPERS_CLI_2026_AXYZ23_SLUG}`;
export const DEVELOPERS_CLI_2026_AXYZ23_LEARN_MORE_SLUG = `${DEVELOPERS_CLI_2026_AXYZ23_SLUG}-learn-more-001`;
export const DEVELOPERS_CLI_2026_AXYZ23_LEARN_MORE_PATH = `/${DEVELOPERS_CLI_2026_AXYZ23_LEARN_MORE_SLUG}`;
export const X_DEVELOPERS_CLI_2026_AXYZ23_SLUG = 'x-developers-cli-2026-axyz23';
export const X_DEVELOPERS_CLI_2026_AXYZ23_PATH = `/${X_DEVELOPERS_CLI_2026_AXYZ23_SLUG}`;
export const X_DEVELOPERS_CLI_2026_AXYZ23_LEARN_MORE_SLUG = `${X_DEVELOPERS_CLI_2026_AXYZ23_SLUG}-learn-more-001`;
export const X_DEVELOPERS_CLI_2026_AXYZ23_LEARN_MORE_PATH = `/${X_DEVELOPERS_CLI_2026_AXYZ23_LEARN_MORE_SLUG}`;

export const X_SIMPLE_SLUG = 'x';
export const X_SIMPLE_PATH = `/${X_SIMPLE_SLUG}`;
export const X_SIMPLE_LEARN_MORE_SLUG = `${X_SIMPLE_SLUG}-learn-more-001`;
export const X_SIMPLE_LEARN_MORE_PATH = `/${X_SIMPLE_LEARN_MORE_SLUG}`;
